import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { AuthInformerComponent } from '@app/layouts/auth/components/auth-informer/auth-informer.component';
import { NzFlexDirective } from 'ng-zorro-antd/flex';
import { ResponsiveService } from '@app/shared/services/responsive/responsive.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'math-auth-layout',
  imports: [
    RouterModule,
    NzLayoutModule,
    NzCardModule,
    NzGridModule,
    AuthInformerComponent,
    NzFlexDirective,
    AsyncPipe,
  ],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {
  public responsive = inject(ResponsiveService);
}
